<script setup lang="ts">
const props = defineProps<{
  min?: Date | string;
  max?: Date | string;
  allowedDates?: unknown[] | ((date: unknown) => boolean);
}>();

const selectedDate = defineModel<Date | string | any>("selectedDate");

const updateYear = (year: number) => {
  const date = selectedDate.value ? new Date(selectedDate.value) : new Date();
  date.setFullYear(year);
  selectedDate.value = date;
};

const updateMonth = (month: number) => {
  const date = selectedDate.value ? new Date(selectedDate.value) : new Date();
  date.setMonth(month);
  selectedDate.value = date;
};
</script>

<template>
  <v-date-picker
    :model-value="typeof selectedDate === 'string' ? new Date(selectedDate) : selectedDate"
    hide-header
    :min="props.min"
    :max="props.max"
    :allowed-dates="props.allowedDates"
    show-adjacent-months
    data-testid="date-picker-view"
    @update:model-value="selectedDate = $event"
    @update:year="updateYear"
    @update:month="updateMonth"
  >
    <template #actions>
      <slot name="actions" />
    </template>
  </v-date-picker>
</template>

<style scoped></style>
